import { trackingAxios } from 'config/api/tracking'
import { IUserRepository } from '../domain/IUserRepository'
import { ErrorResponse, User, UserFilters, UserList } from '../domain/user'
import { UserAdapter } from './UserAdapter'
import { UserToApiAdapter } from './UserToApiAdapter'

interface UserBackendResponse {
    id?: number
    name: string
    email: string
    role_id: number
    warehouse_id?: number
    password?: string
    confirm_password?: string
    warehouse_name?: string
    created_at: string
}

interface PaginatedBackendResponse {
    totalItems: number
    page: number
    size: number
    items: UserBackendResponse[]
}

export class AxiosUserRepository implements IUserRepository {
    constructor() {}

    async get(filters: UserFilters): Promise<UserList> {
        const response = await trackingAxios.get<PaginatedBackendResponse>(
            '/users',
            {
                params: filters,
            }
        )
        return {
            totalItems: response.data.totalItems,
            page: response.data.page,
            size: response.data.size,
            items: response.data.items.map((item) =>
                UserAdapter.toDomain(item)
            ),
        }
    }

    async getById(id: number): Promise<User> {
        const response = await trackingAxios.get<UserBackendResponse>(
            `/users/${id}`
        )
        return UserAdapter.toDomain(response.data)
    }

    async delete(id: number): Promise<void> {
        await trackingAxios.delete(`/users/${id}`)
    }

    async update(id: number, data: Partial<Omit<User, 'id'>>): Promise<User> {
        const apiData = UserToApiAdapter.toApiPartial(data)
        const response = await trackingAxios.patch<UserBackendResponse>(
            `users/${id}/edit`,
            apiData
        )
        const convertedData = UserToApiAdapter.fromApiPartial(response.data)
        return { id: response.data.id, ...convertedData } as User
    }

    async create(data: Omit<User, 'id'>): Promise<User> {
        try {
            const apiData = UserToApiAdapter.toApi(data) // TODO desacoplar esto
            const response = await trackingAxios.post<UserBackendResponse>(
                '/users',
                apiData
            )
            return UserAdapter.toDomain(response.data) // TODO desacoplar esto
        } catch (error) {
            const errorMessage =
                (error as ErrorResponse)?.response?.data?.message ??
                'Error al crear el usuario'
            throw new Error(errorMessage)
        }
    }
}
